import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';


import {Home,Mis,Misentry,Login,Misreport,SalesProjection,FileUploader,OverheadLinkUp, OverheadEntry, 
  OverheadSummary,TargetEntry, MisDashboard, ProSalesProfitAnalysis, UserSettingsMIS} from './pages';

import {Hris,HrLogin,AttnReport,Atten,Leave,AttenRegister,EmployeeInfo,EmployeeEdit,Generate,AddEmployee,
  IctEquipment,AddEquipment, AttendanceAdjustment, DocrInfo, UploadExcel, TypeTest, IpFinder,HRDashboard, 
  LateAttendance,UserSettingsHRIS} from './hrpages';

import {Medical,MedicalLogin,ItemEntry,ItemIssue, ItemReceive, IssueReport, MonthlyIssueRegister, 
  FirstMovingItems, MedicalDashboard, UserSettingsMEDICAL} from './medicalpages';
  
import {Acr,AcrLogin } from './acrpages';
import {Dashboard, DLogin} from './dashboard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

<BrowserRouter>
  <Routes>
    {/* MAIN LAYOUT */}
    <Route path="/" element={<Dashboard />} />
    <Route path="/login" element={<DLogin />} />

    {/* MIS Module */}
    <Route path="/home" element={<Home />}>

      {/* DEFAULT PAGE */}
      <Route index element={<MisDashboard />} />
      <Route path="misDashboard" element={<MisDashboard />} />

      {/* CHILD PAGES */}
      <Route path="mis" element={<Mis />} />
      <Route path="misentry/:id" element={<Misentry />} />
      <Route path="misReport/:branchID/:fYear" element={<Misreport />} />
      <Route path="proSalesProfitAnalysis" element={<ProSalesProfitAnalysis />} />
      <Route path="targetentry" element={<TargetEntry />} />
      <Route path='userSettingsMIS' element={< UserSettingsMIS/>}/>
    </Route>

    {/* HR Module */}
    <Route path="/hris" element={<Hris />}>
        {/* DEFAULT PAGE */}
        <Route index element={<HRDashboard />} />
        <Route path='hrDashboard' element={<HRDashboard/>}/>

        <Route path="attnReport" element={<AttnReport />} />
        <Route path='lateAttendance' element={<LateAttendance/>}/>
        <Route path='leave' element={<Leave/>}/>
        <Route path='attenRegister' element={<AttenRegister/>}/>
        <Route path='attendanceAdjustment' element={< AttendanceAdjustment />}/>
        <Route path='employeeInfo' element={<EmployeeInfo/>}/>
        <Route path='employeeEdit/:id' element={<EmployeeEdit/>}/>
        <Route path='generate' element={< Generate/>}/>
        <Route path='addEmployee' element={< AddEmployee/>}/>
        <Route path='docr' element={< DocrInfo />}/>
        <Route path='userSettingsHRIS' element={< UserSettingsHRIS/>}/>
    </Route>

    {/* MEDICAL Module*/}
    <Route path="/medical" element={<Medical />}>
      {/* DEFAULT PAGE */}
      <Route index element={<MedicalDashboard />} />
      <Route path="medicalDashboard" element={<MedicalDashboard />} />

      <Route path="itementry" element={<ItemEntry />} />
      <Route path='itemissue' element={< ItemIssue />}/>
      <Route path='itemreceive' element={< ItemReceive />} />     
      <Route path='issuereport' element={< IssueReport />}/>
      <Route path='monthlyIssueRegister' element={< MonthlyIssueRegister />}/>
      <Route path='firstMovingItems' element={< FirstMovingItems />}/>
      <Route path='userSettingsMEDICAL' element={< UserSettingsMEDICAL/>}/>
    </Route>

    {/* ICT Module */}
    <Route path='/ict' element={<IctEquipment/>}/>
    <Route path ='/addEquipment' element={<AddEquipment/>}/>

    <Route path='me' element={<Atten/>}></Route>
    <Route path='typeTest' element={<TypeTest/>}/>

  </Routes>
</BrowserRouter>
);